import React from 'react';
import NewsItems from './NewsItems';

export default function NewsArticle() {
  return (
    <div className="flex flex-col p-2 border mx-0 my-5 shadow-sm px-5 py-5 bg-white">
      <div className="relative flex py-5 items-center">
        <div className="grow w-[5%] border" />
        <span
          className="flex-none mx-2 text-main
                  font-bold"
        >
          News and Articles
        </span>
        <div className="grow w-[85%] border" />
      </div>
      <NewsItems />
      <div className="flex justify-end mr-3">
        <a className="flex items-center text-main hover:pointer" href="/">See More</a>
      </div>
    </div>
  );
}
